export default {
  kids: [
    {
      title: "profile.nav.account-details",
      routeName: "/profile/details/account",
    },
    {
      title: "profile.orders",
      routeName: "/profile/orders",
    },
    // {
    //   title: "profile.disputes-and-returns",
    //   routeName: "/profile/disputes",
    // },
    // {
    //   title: "profile.nav.support",
    //   routeName: "/profile/support",
    // },
  ],
  default: [
    {
      title: "profile.nav.account-details",
      routeName: "/profile/details/account",
    },
    {
      title: "profile.orders",
      routeName: "/profile/orders",
    },
    {
      title: "profile.disputes-and-returns",
      routeName: "/profile/disputes",
    },
    {
      title: "profile.nav.history-of-invoices",
      routeName: "/profile/invoices",
    },
    {
      title: "profile.nav.reviews",
      routeName: "/profile/reviews",
    },
    {
      title: "profile.nav.support",
      routeName: "/profile/support",
    },
  ],
}
